/**
 * The always-on agent read panel — sits between the levers and the footer actions, updated on
 * every edit. Judgement in words ("still 2,236 short," "requirement met with 5,537 to spare"),
 * or the dismissible Agent Resolve note when one is standing.
 */

import type { ScenarioContext, ScenarioParams, ScenarioResult } from "@/lib/data";

import { agentAdvice } from "./advice";

export function AgentRead({
  draft,
  result,
  ctx,
  resolveNote,
  resolveTone,
  onDismiss,
}: {
  draft: ScenarioParams;
  result: ScenarioResult;
  ctx: ScenarioContext;
  resolveNote: string | null;
  resolveTone: "ok" | "warn" | "";
  onDismiss: () => void;
}) {
  return (
    <div className="agent-panel">
      <div className="ag-head">
        <span className="ag-dot" />
        Agent read
      </div>
      {resolveNote ? (
        <div
          className={`ag-note ${resolveTone}`}
          onClick={onDismiss}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              onDismiss();
            }
          }}
          // Provider-authored canned copy, same pattern as `field/index.tsx`'s agent replies.
          dangerouslySetInnerHTML={{ __html: resolveNote }}
        />
      ) : (
        agentAdvice(draft, result, ctx).map((line, i) => (
          <div
            key={i}
            className={line.dim ? "ag-line dim" : "ag-line"}
            dangerouslySetInnerHTML={{ __html: line.html }}
          />
        ))
      )}
    </div>
  );
}
